<template>
  <div class="activate-page">
    <div class="bg-decoration">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>

    <desktop-brand-corner />

    <main class="activate-main">
      <section class="activate-card">
        <header class="activate-header">
          <div class="activate-icon">
            <font-awesome-icon icon="user-plus" />
          </div>
          <h1 class="activate-title">注册账号</h1>
        </header>

        <form class="activate-form" @submit.prevent="submitActivate">
          <div class="field-block">
            <label class="field-label" for="activate-username">用户名</label>
            <div class="field-shell">
              <input
                id="activate-username"
                v-model.trim="form.username"
                type="text"
                class="field-input"
                placeholder="4-20个字符，仅支持小写字母、数字、下划线"
              />
            </div>
          </div>

          <div class="field-block">
            <label class="field-label" for="activate-email">邮箱</label>
            <div class="field-shell">
              <input
                id="activate-email"
                v-model.trim="form.email"
                type="email"
                class="field-input"
                placeholder="请输入常用邮箱"
              />
            </div>
          </div>

          <div class="field-block">
            <label class="field-label" for="activate-password">密码</label>
            <div class="field-shell">
              <input
                id="activate-password"
                v-model.trim="form.password"
                type="password"
                class="field-input"
                placeholder="6-20个字符，不能包含空格"
              />
            </div>
          </div>

          <button
            type="submit"
            class="activate-btn"
            :class="{ active: canSubmit }"
            :disabled="!canSubmit"
          >
            注册
          </button>
        </form>
      </section>
    </main>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const form = ref({
  username: '',
  email: '',
  password: '',
})

const canSubmit = computed(
  () =>
    Boolean(
      form.value.username.trim() &&
        form.value.email.trim() &&
        form.value.password.trim()
    )
)

const submitActivate = () => {
  if (!canSubmit.value) {
    return
  }
}
</script>

<style scoped>
.activate-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #fdfbf7 0%, #f5f0e8 50%, #faf8f5 100%);
  padding: 20px;
}

.bg-decoration {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.5;
  animation: float-orb 8s ease-in-out infinite;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, #ffe4d4 0%, #ffd4c4 100%);
  top: -100px;
  right: -100px;
  animation-delay: 0s;
}

.orb-2 {
  width: 350px;
  height: 350px;
  background: linear-gradient(135deg, #e8f4ff 0%, #d4e8ff 100%);
  bottom: -50px;
  left: -100px;
  animation-delay: -3s;
}

.orb-3 {
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, #ffeaa8 0%, #ffd88a 100%);
  top: 50%;
  left: 30%;
  animation-delay: -5s;
}

@keyframes float-orb {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  33% {
    transform: translate(30px, -30px) scale(1.05);
  }

  66% {
    transform: translate(-20px, 20px) scale(0.95);
  }
}

.activate-main {
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 40px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.activate-card {
  width: min(100%, 520px);
  padding: 42px 40px 40px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(255, 255, 255, 0.45) inset;
}

.activate-header {
  text-align: center;
  margin-bottom: 28px;
}

.activate-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  border-radius: 20px;
  background: linear-gradient(135deg, #ff8a3d 0%, #ff6b35 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  box-shadow: 0 12px 24px rgba(255, 138, 61, 0.35);
}

.activate-title {
  font-size: 30px;
  line-height: 1.1;
  font-weight: 800;
  color: #2d3436;
}

.activate-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.field-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.field-label {
  font-size: 16px;
  font-weight: 700;
  color: #4f4137;
}

.field-shell {
  min-height: 72px;
  border-radius: 22px;
  padding: 0 20px;
  background: rgba(249, 244, 236, 0.88);
  box-shadow: inset 0 0 0 1px rgba(201, 177, 151, 0.34);
  display: flex;
  align-items: center;
  transition: box-shadow 0.25s ease, background 0.25s ease;
}

.field-shell:focus-within {
  background: rgba(255, 255, 255, 0.96);
  box-shadow: inset 0 0 0 2px rgba(255, 138, 61, 0.38);
}

.field-input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  color: #352c26;
  font-size: 18px;
  line-height: 1.5;
}

.field-input::placeholder {
  color: #a69b90;
}

.activate-btn {
  width: 100%;
  min-height: 78px;
  margin-top: 8px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(180deg, #e6dfd6 0%, #d8cfc4 100%);
  color: rgba(50, 42, 35, 0.72);
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 4px;
  cursor: not-allowed;
  box-shadow: 0 12px 24px rgba(153, 120, 87, 0.08);
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    background 0.25s ease,
    color 0.25s ease;
}

.activate-btn.active {
  background: linear-gradient(135deg, #ff8a3d 0%, #ff6b35 100%);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(255, 138, 61, 0.35);
}

.activate-btn.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(255, 138, 61, 0.5);
}

@media (max-width: 520px) {
  .activate-page {
    padding: 16px;
  }

  .activate-main {
    min-height: calc(100vh - 32px);
  }

  .activate-card {
    padding: 34px 24px 30px;
    border-radius: 26px;
  }

  .activate-title {
    font-size: 26px;
  }

  .field-shell {
    min-height: 64px;
    border-radius: 20px;
  }

  .field-input {
    font-size: 16px;
  }

  .activate-btn {
    min-height: 56px;
    font-size: 17px;
  }
}
</style>
